<script setup lang="ts">

/*
	LabelItem.vue
	
	Renderable text label with selection state and repositioning. These are 
	draggable text elements that can be placed anywhere on the tablemap canvas.
	
	Features:
	- Draggable positioning with position-changed emission on drag end
	- Selection box around label when selected
	- Customizable text, font size, and font family
	- Custom text color fill
*/

import type { Label } from '~/lib/seatmapeditor/types'

interface Props {
	label: Label
	isSelected: boolean
}

interface Emits {
	(e: 'select'): void
	(e: 'position-changed', x: number, y: number): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const onDragEnd = (event: any) => {
	emit('position-changed', event.target.x(), event.target.y())
}
</script>

<template>
	<v-group
		:config="{
			x: label.x,
			y: label.y,
			draggable: true,
			onDragEnd,
			onClick: () => emit('select'),
			onTap: () => emit('select')
		}"
	>
		<v-rect
			v-if="isSelected"
			:config="{
				x: -4,
				y: -4,
				width: Math.max(label.text.length * (label.fontSize * 0.6), 50),
				height: label.fontSize + 8,
				fill: '#ffffff',
				stroke: '#0284c7',
				strokeWidth: 2,
				cornerRadius: 4,
				listening: false,
				perfectDrawEnabled: false
			}"
		/>

		<v-text
			:config="{
				text: label.text,
				fontSize: label.fontSize,
				fontFamily: label.fontFamily,
				fill: label.fill,
				align: 'left',
				verticalAlign: 'top',
				perfectDrawEnabled: false
			}"
		/>
	</v-group>
</template>
